<template>
  <v-container fluid id="docForm">
    <v-card>
      <v-toolbar dense flat color="secondary">
        <v-toolbar-title>Create Warehouse Order</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text to="/warehouse-orders">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>

      <v-card-text>

      </v-card-text>
    </v-card>


    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>
  
  
  <script>

import { v4 as uuidv4 } from 'uuid';
export default {
  name: "NewPurchaseOrder",
  components: {

  },
  props: {
    initial: {
      type: Object,
      required: true
    },
    docCreate: {
      type: Boolean
    }
  },
  data: () => ({
    record: {},
    loader: false,
    pageItems: 100,
    supplierDialog: false,
    supplierItem: {},
    productDialog: false,
    productItem: {},
    purchaseDialog: false,
    purchaseItem: {},
    taxGroups: [],
    selectedProduct: null,
    searchProducts: null,
    SumApplied: null,
    selectedItems: [],
    activeRow: null,
    storeId: null,
    singleSelect: true,
    paymentMode: null,
    searchSuppliers: null,
    accounts: [],
    orderItems: [],
    suppliers: [],
    products: [],
    stores: [],
    date: new Date().toISOString().substr(0, 10),
    todayDate: new Date().toISOString().substr(0, 10),
    dateReadonly: "",
    headers: [
      { text: "No.", value: "num" },
      { text: "Product", value: "Name" },
      { text: "Qty", value: "Quantity" },
      { text: "Uom", value: "uomEntryName" },
      { text: "Price", value: "Price" },
      { text: "Total", value: "DisplayTotal" },
      { text: "Action", value: "action" }
    ]
  }),
  computed: {
    role() {
      return localStorage.getItem("userRole");
    },
    activeStore() {
      return localStorage.getItem("store_id");
    },
    totalAmount() {
      let total = 0;
      if (typeof this.orderItems != "undefined" && this.orderItems.length > 0) {
        return this.orderItems
          .map(item => {
            const amount = item.LineTotal;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    balance() {
      let sum = 0;
      if (this.SumApplied) {
        sum = this.SumApplied;
      }
      return this.totalAmount - parseFloat(sum);
    },
    displayBalance() {
      let bal = 0;
      if (this.docCreate == true) {
        bal = this.balance.toLocaleString();
      } else {
        bal = this.record.Balance;
      }
      return bal;
    },
    totalDisplayAmount() {
      return this.totalAmount.toLocaleString();
    },
    PaidSum() {
      let paid = 0;
      if (this.record.PaidSum) {
        paid = this.record.PaidSum.toLocaleString();
      }
      return paid;
    }
  },
  watch: {
    initial: {
      handler: "init",
      immediate: true
    },
    searchSuppliers(val) {
      if (val && val !== this.select && this.querySuppliers(val)) {
        this.querySuppliers(val);
      }
    },
    searchProducts(val) {
      if (val && val !== this.select && this.querySelections(val)) {
        this.querySelections(val);
      }
    }
  },
  methods: {
    init(val) {
      this.record = { ...val };
      const products = [];
      if (val.rows) {
        for (const row of val.rows) {
          row.DisplayTotal = row.LineTotal.toLocaleString();
          products.push(row);
        }
        this.orderItems = products;
      }
    },
    saveProduct(data) {
        data.store_id = parseInt(this.activeStore);
      const url = "/products";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.productDialog = false;
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show("Product added Successfully", "green");
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    productModal() {
      this.productDialog = true;
    },
    saveSupplier(data) {
      const url = "/suppliers";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            const supplier = res.ResponseData;
            self.suppliers = [...this.suppliers, supplier];
            self.record.CardCode = supplier.id;
            self.$refs.snackbar.show("Supplier Added Successully", "green");
            self.supplierDialog = false;
            self.$store.commit("btnLoader", false);
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    openCreate() {
      this.supplierDialog = true;
    },
    querySelections(searchText) {
      const self = this;
      const url = "/products/search";

      const data = {
        searchText: searchText
      };
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData != null && res.ResponseData.length > 0) {
              self.products = res.ResponseData;
            }
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    querySuppliers(searchText) {
      const self = this;
      const url = "/suppliers/search";
      const data = {
        searchText: searchText
      };

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.suppliers = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    openModal() {
      this.purchaseItem = {};
      this.purchaseItem.id = null;
      this.purchaseDialog = true;
    },
    uomChanged(item) {
      this.purchaseItem.Price = null;
      let ugp1 = [];
      ugp1 = item.ugp1;
      if (ugp1) {
        let ugp1Record = ugp1.find(record => {
          return record.UomEntry === item.UomEntry;
        });
        this.purchaseItem.uomEntryName = ugp1Record.UomName;
        this.purchaseItem.Price = ugp1Record.BuyingPrice;

        // update LineTotal
        var total = this.purchaseItem.Quantity * this.purchaseItem.Price;
        console.log(total);
        this.purchaseItem.LineTotal = total;
      }
    },
    qtyChanged(data) {
      let Price;
      let Quantity;
      if (data.Price) {
        Price = parseFloat(data.Price);
      } else {
        Price = 0;
      }
      if (data.Quantity) {
        Quantity = parseFloat(data.Quantity);
      } else {
        Quantity = 0;
      }
      const LineTotal = Price * Quantity;

      const DisplayTotal = LineTotal.toLocaleString();
      // find item

      this.purchaseItem.LineTotal = LineTotal;
      this.purchaseItem.DisplayTotal = DisplayTotal;
    },
    addProduct() {
      if (
        this.purchaseItem.Quantity == null ||
        this.purchaseItem.Price == null ||
        this.purchaseItem.id == null
      ) {
        this.$refs.snackbar.show("Please fill all the fields", "red");
      } else {
        const self = this;
        const initArray = [];
        initArray.push(self.purchaseItem);
        self.orderItems = [...self.orderItems, ...initArray];
        this.purchaseItem = {};
        this.purchaseDialog = false;
      }
    },
    setDate(date) {
      this.date = date;
    },
    deleteRow(item) {
      const selectedRow = this.orderItems.find(record => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.orderItems.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.orderItems.splice(pos, 1);
    },
    selectedRow($event) {
      this.activeRow = $event.item.o_i_t_m_s_id;
    },
    setOrderItem(id) {
      const store_id = this.activeStore;
      const self = this;
      // fetch the product from database
      this.$store
        .dispatch("get", `/products/${id}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            const product = res.ResponseData;
            // current item definition
            let currentItem = {};
            currentItem.Quantity = null;
            currentItem.ManualStatus = product.HasUom == 0 ? "Y" : "N";
            currentItem.UomEntry = product.PUoMEntry;
            currentItem.o_i_t_m_s_id = id;
            currentItem.Name = product.Name;
            currentItem.store_id = store_id;
            const LineNum = new Date().getTime();
            currentItem.LineNum = LineNum;
            currentItem.DiscSum = null;
            // end

            if (product.HasUom === 0) {
              // check if manual yes and assign
              var buyingPrice = product.buyingPrice;
              currentItem.BuyingPrice = buyingPrice;
              currentItem.Price = buyingPrice;
              currentItem.currentPrice = buyingPrice;
              const total = 0;
              currentItem.LineTotal = total;
              currentItem.DisplayTotal = 0;

              this.select = null;
              // end of manual yes
            }

            // start of manual No status
            if (product.HasUom === 1) {
              let ugp1Data = product.ugp1;
              const ugp1Record = ugp1Data.find(record => {
                return record.UomEntry === product.PUoMEntry;
              });
              currentItem.ugp1 = product.ugp1;
              currentItem.Price = ugp1Record.BuyingPrice;
              currentItem.currentPrice = ugp1Record.BuyingPrice;
              const total = 0;
              currentItem.LineTotal = total;
              currentItem.DisplayTotal = 0;
              this.select = "";
              self.products = [];
              // end of push
            }

            this.purchaseItem = { ...this.purchaseItem, ...currentItem };
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
      // end of fetch
    },
    generateUniqueId() {
      var subscriberId = localStorage.getItem("subscriber_id");
      var date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      var dateString = `${year}-${month}-${day}`;
      var uniqueId = `${uuidv4()}-${dateString}-${subscriberId}`;
      return uniqueId;
    },
    sendData() {
      if (
        this.record.SupplierId == null ||
        this.record.SupplierId == undefined
      ) {
        this.$refs.snackbar.show("Please select supplier !", "red");
        return;
      }

      if (this.date == null || this.date == undefined) {
        this.$refs.snackbar.show("Please select date!", "red");
        return;
      }

      if (this.orderItems.length <= 0) {
        this.$refs.snackbar.show("You must have at least one product", "red");
        return;
      }

      var uniqueId = this.generateUniqueId();

      let saleDate = this.date;
      this.record = { ...this.record, DocDate: saleDate };
      const data = this.record;
      data.ObjType = 11;
      data.UniqueId = uniqueId;
      data.DocTotal = this.totalAmount;
      data.DocNum = this.DocNum;
      data.CreatedBy = this.UserSign;
      data.ref2 = this.ref2;
      var storeId = parseInt(this.activeStore);
      data.storeId = storeId;
      data.CreatedBy = parseInt(this.userSign);
      data.terms = this.terms;

      // append order rows
      var orderData = this.orderItems;

      var rows = [];
      for (const row of orderData) {
        var details = {
          productId: row.o_i_t_m_s_id,
          UomEntry: row.UomEntry,
          Quantity: parseFloat(row.Quantity),
          Price: parseFloat(row.Price),
          LineTotal: parseFloat(row.LineTotal),
          name: row.Name,
          storeId: storeId
        };

        rows.push(details);
      }
      // end

      data.rows = rows;

      // save data
      const url = "/create-lpo";
      const self = this;
      self.$store.commit("btnLoader", true);
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.getDocNum();
            const NewDate = this.record.DocDate;
            self.record = {};
            self.record.DocDate = NewDate;
            if (self.clearDate == "Y") {
              this.$refs.dateRef.clearDate();
            }
            self.orderItems = [];
            self.SumApplied = 0;
            self.DiscOnTotal = 0;
            self.ref2 = null;
            self.UserSign = null;
            this.$refs.snackbar.show("Created successful", "green");
            self.$router.push("/purchase-orders");
            self.$store.commit("btnLoader", false);
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/bank-accounts`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.dateReadonly = res.ResponseData.dateReadonly;
            if (res.ResponseData.DefaultStockStore) {
              if (self.docCreate) {
                self.record.DocDate = new Date().toISOString().substr(0, 10);
              }
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getDocNum() {
      const self = this;
      this.$store
        .dispatch("get", `/document-numbering/12`)
        .then(res => {
          if (res.ResultCode == 1200) {
            if (self.docCreate == true) {
              self.record = {
                ...self.record,
                DocNum: res.ResponseData.NextNumber
              };
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    Promise.all([
      this.getAccounts(),
      this.getStores(),
      this.getGenSettings(),
      this.getDocNum()
    ]);
  }
};
</script>
  
  <style  scoped>
/* .v-text-field__details {
    display: none !important;
  } */
</style>